import AddIcon from '@mui/icons-material/Add'
import ExploreIcon from '@mui/icons-material/Explore'
import HomeIcon from '@mui/icons-material/Home'
import PersonIcon from '@mui/icons-material/Person'
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer'
import ScheduleIcon from '@mui/icons-material/Schedule'
import { Badge, BottomNavigation, BottomNavigationAction, Paper } from '@mui/material'
import { useAtomValue } from 'jotai'
import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router'

import { fullScreenAtom } from '../../contexts/AtomUtil'
import Config from '../../data/Config'
import { hasUnreadMessagesAtom, totalUnreadCountAtom } from '../../domains/chat/AtomChats'

const actionSx = {
  transition: 'all 0.3s ease',
  '&.Mui-selected': {
    transform: 'translateY(-4px)',
    '& .MuiBottomNavigationAction-label': {
      textShadow: '0 0 1px rgba(0,0,0,0.2)',
      fontSize: '0.75rem',
    },
    '& .MuiSvgIcon-root': {
      fontSize: '2rem',
    },
  },
}

const badgeSx = {
  '& .MuiBadge-badge': {
    fontSize: '0.6rem',
    minWidth: '16px',
    height: '16px',
    padding: '0 4px',
  },
}

export default function SimpleBottomNavigation({ sx }) {
  const [value, setValue] = useState(0)
  const location = useLocation()
  const navigate = useNavigate()

  const fullScreen = useAtomValue(fullScreenAtom)
  const hasUnreadMessages = useAtomValue(hasUnreadMessagesAtom)
  const totalUnreadCount = useAtomValue(totalUnreadCountAtom)

  // 根据当前路径更新选中项
  useEffect(() => {
    const paths = ['/', '/events', '/booking', '/mysessions', ...(Config.CHAT_ENABLED ? ['/chat'] : []), '/profile']
    const index = paths.findIndex((path) => path === location.pathname)
    if (index !== -1) {
      setValue(index)
    }
  }, [location.pathname])

  // 检查是否隐藏导航栏
  const shouldHideNavigation = new URLSearchParams(location.search).get('focus') === 'true'

  if (shouldHideNavigation || fullScreen) {
    return null
  }

  const handleNavigationChange = (event, newValue) => {
    const paths = ['/', '/events', '/booking', '/mysessions', ...(Config.CHAT_ENABLED ? ['/chat'] : []), '/profile']
    const newPath = paths[newValue]
    if (location.pathname === newPath) {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    } else {
      navigate(newPath)
    }
    setValue(newValue)
  }

  const chatIcon = hasUnreadMessages ? (
    <Badge badgeContent={totalUnreadCount > 99 ? '99+' : totalUnreadCount} color="error" overlap="circular" anchorOrigin={{ vertical: 'top', horizontal: 'right' }} sx={badgeSx}>
      <QuestionAnswerIcon />
    </Badge>
  ) : (
    <QuestionAnswerIcon />
  )

  return (
    <Paper {...sx} elevation={3}>
      <BottomNavigation
        showLabels
        value={value}
        onChange={handleNavigationChange}
        sx={{
          height: 75,
          pb: 1,
          px: 2,
          '& .MuiBottomNavigationAction-root': {
            minWidth: 'auto',
            '& .MuiBottomNavigationAction-label': {
              fontSize: '0.65rem',
              marginTop: 0,
            },
          },
        }}
      >
        <BottomNavigationAction label="Home" icon={<HomeIcon />} value={0} sx={actionSx} />
        <BottomNavigationAction label="Events" icon={<ExploreIcon />} value={1} sx={actionSx} />
        <BottomNavigationAction label="Booking" icon={<AddIcon />} value={2} sx={actionSx} />
        <BottomNavigationAction label="Sessions" icon={<ScheduleIcon />} value={3} sx={actionSx} />
        {Config.CHAT_ENABLED && <BottomNavigationAction label="Chat" icon={chatIcon} value={4} sx={actionSx} />}
        <BottomNavigationAction label="Profile" icon={<PersonIcon />} value={Config.CHAT_ENABLED ? 5 : 4} sx={actionSx} />
      </BottomNavigation>
    </Paper>
  )
}
